import { createFileRoute } from "@tanstack/react-router"

import { materialsSearchSchema } from "@/features/materials/materials-search-schema"
import { Perm } from "@/lib/permissions"
import { requirePermission } from "@/lib/route-guards"
import { SettingsMaterialLibraryPage } from "@/pages/settings/material-library"

export const Route = createFileRoute("/_authenticated/settings/material-library")({
	validateSearch: (search) => materialsSearchSchema.parse(search),
	beforeLoad: async ({ context }) => {
		// The library is account configuration — admin/owner only, same gate as the API.
		await requirePermission(context, Perm.ACCOUNT_SETTINGS_UPDATE, { to: "/settings/account/profile" })
	},
	component: SettingsMaterialLibraryPage
})
